// AttachInterviewTab.tsx
import React from "react";
import { CardBody } from "../../../components/bootstrap/Card";
import FormGroup from "../../../components/bootstrap/forms/FormGroup";
import Select from "../../../components/bootstrap/forms/Select";
import UserStatus from "../Interview_Mode";
import Button from "../../../components/bootstrap/Button";
import { toast } from "react-toastify";
import Input from '../../../components/bootstrap/forms/Input';
import usejobRequisition from '../../../components/utils/PermissionChecking';
import Label from "../../../components/bootstrap/forms/Label";
import { User } from "../../Role_Layout/roleTypes";
import CheckboxDropdown from "../../../components/bootstrap/forms/CheckboxDropdown";

interface AttachInterviewTabProps {
    formik: any;
    roundtypes: any[];
    roundType: any[];
    intDetail: any[];
    filteredUsers: any[];
    feedbackDrop: any[];
    scheduleDuration: any[];
    // eslint-disable-next-line react/require-default-props
    updateItem?: any;
    setUpdateItem: (item: any) => void;
    navigate: (path: string) => void;
    themeStatus: string;
}

const AttachInterviewTab: React.FC<AttachInterviewTabProps> = ({
    formik,
    roundtypes,
    roundType,
    intDetail,
    filteredUsers,
    feedbackDrop,
    scheduleDuration,
    updateItem,
    setUpdateItem,
    navigate,
    themeStatus,
}) => {
    const { hasPermission } = usejobRequisition();
    const moduleName = 'Job Requisition';
    const canAttachInterview = hasPermission(moduleName, 'attach interview');
    function capitalizeWords(str: string | undefined): string {
        if (!str) return '';
        return str
            .toLowerCase()
            .split(' ')
            .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
    return (
        <CardBody>
            <form onSubmit={formik.handleSubmit}>
                <div className='row mb-3'>
                    <div className='col-4'>
                        <FormGroup
                            id='round-type'
                            label='Round Types'
                            className='mb-3'>
                            <Select
                                id='roundTypes'
                                name='roundTypes'
                                ariaLabel='roundTypes'
                                placeholder='Select Round Type'
                                value={formik.values.roundTypes}
                                disabled={
                                    roundtypes.filter(
                                        (rt) =>
                                            !intDetail.some(
                                                (res) =>
                                                    res.roundType ===
                                                    rt.name,
                                            ),
                                    ).length === 0 && !updateItem
                                }
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    formik.setFieldValue(
                                        'interviewerId',
                                        [],
                                    );
                                    formik.setFieldValue(
                                        'feedback',
                                        [],
                                    );
                                }}
                                list={
                                    updateItem
                                        ? roundtypes
                                            .filter(
                                                (rt) =>
                                                    !roundType.some(
                                                        (res) =>
                                                            res.roundType ===
                                                            rt.name &&
                                                            rt.name !==
                                                            updateItem.roundType,
                                                    ),
                                            )
                                            .map((rt) => ({
                                                value: rt.name,
                                                text: rt.name,
                                            }))
                                        : roundtypes
                                            .filter(
                                                (rt) =>
                                                    !roundType.some(
                                                        (res) =>
                                                            res.roundType ===
                                                            rt.name,
                                                    ),
                                            )
                                            .map((rt) => ({
                                                value: rt.name,
                                                text: rt.name,
                                            }))
                                }
                                onBlur={formik.handleBlur}
                                isTouched={!!formik.touched.roundTypes}
                                invalidFeedback={
                                    typeof formik.errors.roundTypes ===
                                        'string'
                                        ? formik.errors.roundTypes
                                        : undefined
                                }
                                isValid={
                                    formik.isValid &&
                                    !formik.errors.roundTypes
                                }
                            />
                        </FormGroup>
                    </div>
                    <div className="col-4">
                        <CheckboxDropdown
                            id="interviewers"
                            label="Interviewers"
                            options={filteredUsers.map((u) => ({
                                value: u.id,
                                text: `${u.fName} ${u.lName}`,
                            }))}
                            value={formik.values.interviewerId}
                            onChange={(vals) => formik.setFieldValue("interviewerId", vals)}
                            placeholder={(() => {
                                if (filteredUsers.length === 0) {
                                    if (formik.values.roundTypes === "HR") {
                                        return "No HR Interviewers Available";
                                    }
                                    return "No Interviewers Available";
                                }
                                return "Select Interviewers";
                            })()}
                            disabled={filteredUsers.length === 0}
                            isTouched={formik.touched.interviewerId}
                            invalidFeedback={
                                typeof formik.errors.interviewerId === "string"
                                    ? formik.errors.interviewerId
                                    : undefined
                            }
                            isValid={formik.isValid && !formik.errors.interviewerId}
                        />
                    </div>
                    <div className='col-4'>
                        <FormGroup
                            id='feedback'
                            label='Feedback Form'
                            className='mb-3'>
                            <Select
                                id='feedback'
                                name='feedback'
                                ariaLabel='feedback'
                                placeholder='Select Feedback form'
                                value={formik.values.feedback}
                                disabled={feedbackDrop.length === 0}
                                list={feedbackDrop.map((item) => ({
                                    value: item.id,
                                    text: capitalizeWords(
                                        item.roleTitle,
                                    ),
                                }))}
                                onChange={(
                                    e: React.ChangeEvent<HTMLSelectElement>,
                                ) => {
                                    const values = Array.from(
                                        e.target.selectedOptions,
                                    ).map((option) => option.value);
                                    formik.setFieldValue(
                                        'feedback',
                                        values,
                                    );
                                }}
                                onBlur={formik.handleBlur}
                                isTouched={!!formik.touched.feedback}
                                invalidFeedback={
                                    typeof formik.errors.feedback ===
                                        'string'
                                        ? formik.errors.feedback
                                        : undefined
                                }
                                isValid={
                                    formik.isValid &&
                                    !formik.errors.feedback
                                }
                            />
                        </FormGroup>
                    </div>
                </div>


                <div className='row gx-3 gy-3'>
                    <div className='col-12 col-md-6 col-lg-3'>
                        <FormGroup
                            id='scheduleTimeFrom'
                            label='Schedule Time from'
                            className='mb-0'>
                            <Input
                                type='time'
                                id='scheduleTimeFrom'
                                className='form-control py-2'
                                placeholder='Enter Schedule Time from'
                                value={formik.values.scheduleTimeFrom}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isTouched={
                                    !!formik.touched.scheduleTimeFrom
                                }
                                invalidFeedback={
                                    formik.errors.scheduleTimeFrom
                                }
                                isValid={
                                    formik.isValid &&
                                    !formik.errors.scheduleTimeFrom
                                }
                                name='scheduleTimeFrom'
                            />
                        </FormGroup>
                    </div>

                    <div className='col-12 col-md-6 col-lg-3'>
                        <FormGroup
                            id='scheduleTimeTo'
                            label='Interview Length'
                            className='mb-0'>
                            <Select
                                id='scheduleTimeTo'
                                name='scheduleTimeTo'
                                ariaLabel='scheduleTimeTo'
                                placeholder='Select in Minutes'
                                value={formik.values.scheduleTimeTo}
                                list={scheduleDuration.map((item) => ({
                                    value: item.name,
                                    text: item.name,
                                }))}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isTouched={
                                    !!formik.touched.scheduleTimeTo
                                }
                                invalidFeedback={
                                    formik.errors.scheduleTimeTo
                                }
                                isValid={
                                    formik.isValid &&
                                    !formik.errors.scheduleTimeTo
                                }
                            />
                        </FormGroup>
                    </div>

                    <div className='col-12 col-lg-4 mt-3'>
                        <Label htmlFor='mode' className='w-100'>
                            Interview Mode
                        </Label>
                        <UserStatus
                            status={
                                formik.values.mode as
                                | 'Online'
                                | 'Offline'
                            }
                            setStatus={(value) =>
                                formik.setFieldValue('mode', value)
                            }
                        />
                    </div>
                </div>

                <div className='row mt-4'>
                    <div className='col d-flex justify-content-end gap-2'>
                        <div className='col-2'>
                            <Button
                                className='w-100'
                                color='dark'
                                style={{
                                    transition:
                                        'background 0.3s ease, transform 0.2s ease',
                                    borderRadius: '0.5rem',
                                }}
                                onMouseEnter={(e) => {
                                    (
                                        e.target as HTMLButtonElement
                                    ).style.transform = 'scale(1.02)';
                                }}
                                onMouseLeave={(e) => {
                                    (
                                        e.target as HTMLButtonElement
                                    ).style.transform = 'scale(1)';
                                }}
                                onClick={() => {
                                    if (updateItem) {
                                        formik.resetForm();
                                        setUpdateItem(undefined);
                                        if (
                                            roundtypes
                                                .filter(
                                                    (round) =>
                                                        !roundType.some(
                                                            (res) =>
                                                                res.roundType ===
                                                                round.name,
                                                        ),
                                                )
                                                .map((item) => ({
                                                    value: item.name,
                                                    text: item.name,
                                                })).length === 0
                                        ) {
                                            toast.info(
                                                'All Rounds are assigned to this job requisition',
                                                {
                                                    closeOnClick: true,
                                                },
                                            );
                                        }
                                    } else {
                                        navigate('/Requirement');
                                    }
                                }}>
                                Cancel
                            </Button>
                        </div>
                        <div className='col-2'>
                            <Button
                                isDisable={!canAttachInterview}
                                className='w-100  bg-primary hrms-gradient-btn'
                                type='submit'>
                                {updateItem ? 'Update' : 'Save'}
                            </Button>
                        </div>
                    </div>
                </div>
            </form>
        </CardBody>
    );
};

export default AttachInterviewTab;